/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Confirm_DeleteInputs */

const en_admin_categories_confirm_delete = /** @type {(inputs: Admin_Categories_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const zh_admin_categories_confirm_delete = /** @type {(inputs: Admin_Categories_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Admin_Categories_Confirm_DeleteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_confirm_delete = /** @type {((inputs?: Admin_Categories_Confirm_DeleteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Confirm_DeleteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_confirm_delete(inputs)
	return zh_admin_categories_confirm_delete(inputs)
});
export { admin_categories_confirm_delete as "admin.categories.confirm_delete" }